in table


<template>
  <div>
    <h3 class="text-lg font-semibold text-ds-button-color mb-3">
      👤 Agent Information
    </h3>
    <table class="w-full border-collapse mb-8">
      <tbody>
        <tr class="border-b hover:bg-gray-50">
          <td class="py-3 px-4 font-medium text-gray-600 w-1/3">Full Name</td>
          <td class="py-3 px-4 text-gray-900">{{ formData.name || "—" }}</td>
        </tr>
        <tr class="border-b hover:bg-gray-50">
          <td class="py-3 px-4 font-medium text-gray-600">Birthdate</td>
          <td class="py-3 px-4 text-gray-900">{{ formData.birthdate || "—" }}</td>
        </tr>
        <tr class="border-b hover:bg-gray-50">
          <td class="py-3 px-4 font-medium text-gray-600">Address</td>
          <td class="py-3 px-4 text-gray-900">{{ formData.address || "—" }}</td>
        </tr>
        <tr class="border-b hover:bg-gray-50">
          <td class="py-3 px-4 font-medium text-gray-600">Email</td>
          <td class="py-3 px-4 text-gray-900">{{ formData.email || "—" }}</td>
        </tr>
      </tbody>
    </table>
    <h3 class="text-lg font-semibold text-ds-button-color mb-3">
      💼 Work Information
    </h3>
    <table class="w-full border-collapse mb-8">
      <tbody>
        <tr class="border-b hover:bg-gray-50">
          <td class="py-3 px-4 font-medium text-gray-600 w-1/3">Broker</td>
          <td class="py-3 px-4 text-gray-900">{{ formData.broker }}</td>
        </tr>
        <tr class="border-b hover:bg-gray-50">
          <td class="py-3 px-4 font-medium text-gray-600">Designation</td>
          <td class="py-3 px-4 text-gray-900">{{ formData.designation }}</td>
        </tr>
        <tr class="border-b hover:bg-gray-50">
          <td class="py-3 px-4 font-medium text-gray-600">Broker Code</td>
          <td class="py-3 px-4 text-gray-900">{{ formData.brokercode }}</td>
        </tr>
      </tbody>
    </table>
    <h3 class="text-lg font-semibold text-ds-button-color mb-3">
      🚨 Emergency Contact
    </h3>
    <table class="w-full border-collapse mb-8">
      <tbody>
        <tr class="border-b hover:bg-gray-50">
          <td class="py-3 px-4 font-medium text-gray-600 w-1/3">Name</td>
          <td class="py-3 px-4 text-gray-900">{{ formData.emerName }}</td>
        </tr>
        <tr class="border-b hover:bg-gray-50">
          <td class="py-3 px-4 font-medium text-gray-600">Cellphone No.</td>
          <td class="py-3 px-4 text-gray-900">{{ formData.emerCellphoneno }}</td>
        </tr>
        <tr class="border-b hover:bg-gray-50">
          <td class="py-3 px-4 font-medium text-gray-600">Address</td>
          <td class="py-3 px-4 text-gray-900">{{ formData.emerAddress }}</td>
        </tr>
      </tbody>
    </table>
    <h3 class="text-lg font-semibold text-ds-button-color mb-3">
      🧷 Uploaded Documents
    </h3>
    <table class="w-full border-collapse">
      <tbody>
        <tr class="border-b hover:bg-gray-50">
          <td class="py-3 px-4 font-medium text-gray-600 w-1/3">1x1 Photo</td>
          <td class="py-3 px-4 text-gray-900">
            {{ formData.photo ? formData.photo.name : "No file uploaded" }}
          </td>
        </tr>
        <tr class="border-b hover:bg-gray-50">
          <td class="py-3 px-4 font-medium text-gray-600">Valid ID</td>
          <td class="py-3 px-4 text-gray-900">
            {{ formData.validid ? formData.validid.name : "No file uploaded" }}
          </td>
        </tr>
        <tr>
          <td class="py-3 px-4 font-medium text-gray-600">Resume / CV</td>
          <td class="py-3 px-4 text-gray-900">
            {{ formData.resume ? formData.resume.name : "No file uploaded" }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: ["formData"],
  emits: ["confirm"],
  setup(props, { emit }) {
    return {
      props,
      emit,
    };
  },
};
</script>